import { MarketOrderDto } from '@careapp-group/ng-sdk';
import {
  BaseFilterType,
  CaEntityActionsFactory,
} from '../../../store/entity-state/entity-actions-factory';
import { createAction } from '@ngrx/store';
import { props } from '@ngrx/store';

class MarketManagementOrderActions extends CaEntityActionsFactory<
  MarketOrderDto,
  unknown,
  unknown,
  BaseFilterType
> {
  constructor() {
    super('MarketManagementOrder');
  }
  get REQUEST_COMPLETE_ORDER() {
    return `[${this.type}][Request] complete order`;
  }
  get RESPONSE_SUCCESS_COMPLETE_ORDER() {
    return `[${this.type}][Response][Success] complete order`;
  }
  get RESPONSE_FAIL_COMPLETE_ORDER() {
    return `[${this.type}][Response][Fail] complete order`;
  }
  get UPDATE_SEGMENT_PAGE_COUNT() {
    return `[${this.type}][Update] segment page count`;
  }

  RequestCompleteOrderAction = createAction(
    this.REQUEST_COMPLETE_ORDER,
    props<{ orderId: string; comment?: string }>(),
  );

  ResponseSuccessCompleteOrderAction = createAction(
    this.RESPONSE_SUCCESS_COMPLETE_ORDER,
    props<{ orderId: string; order: MarketOrderDto }>(),
  );

  ResponseFailCompleteOrderAction = createAction(
    this.RESPONSE_FAIL_COMPLETE_ORDER,
    props<{ orderId: string; error: any }>(),
  );

  RequestCancelOrderAction = createAction(
    `[${this.type}][Request] cancel order`,
    props<{ orderId: string; reason: string }>(),
  );

  ResponseSuccessCancelOrderAction = createAction(
    `[${this.type}][Response][Success] cancel order`,
    props<{ orderId: string; order: MarketOrderDto }>(),
  );

  ResponseFailCancelOrderAction = createAction(
    `[${this.type}][Response][Fail] cancel order`,
    props<{ orderId: string; error: any }>(),
  );

  UpdateSegmentPageCountAction = createAction(
    this.UPDATE_SEGMENT_PAGE_COUNT,
    props<{ segment: string; count: number }>(),
  );
}

export const MarketManagementOrder = new MarketManagementOrderActions();
